const MOBILE_MEDIA_QUERY = window.matchMedia('(max-width: 749px)');
const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

class ScrollableImageCards extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-image-cards-scroller]');
    this.cards = Array.from(this.querySelectorAll('[data-image-card]'));
    this.firstMedia = this.cards[0]?.querySelector('.image-text-cards__media');
    this.previousButton = this.querySelector('[data-image-cards-previous]');
    this.nextButton = this.querySelector('[data-image-cards-next]');

    if (!this.scroller || !this.previousButton || !this.nextButton) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.previousButton.addEventListener('click', () => this.move(-1), { signal });
    this.nextButton.addEventListener('click', () => this.move(1), { signal });
    this.scroller.addEventListener('keydown', this.handleKeydown, { signal });

    this.resizeObserver = new ResizeObserver(this.updateControls);
    this.resizeObserver.observe(this.scroller);
    if (this.firstMedia) this.resizeObserver.observe(this.firstMedia);

    requestAnimationFrame(this.updateControls);
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.resizeObserver?.disconnect();
  }

  move(direction) {
    if (!this.cards.length || this.previousButton.hidden) return;

    const maximumScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
    const positions = this.cards.map((card) => Math.min(card.offsetLeft, maximumScroll));
    const currentIndex = positions.reduce((nearestIndex, position, index) => {
      const nearestDistance = Math.abs(positions[nearestIndex] - this.scroller.scrollLeft);
      return Math.abs(position - this.scroller.scrollLeft) < nearestDistance ? index : nearestIndex;
    }, 0);
    const nextIndex = (currentIndex + direction + this.cards.length) % this.cards.length;

    this.scroller.scrollTo({
      left: positions[nextIndex],
      behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth',
    });
  }

  updateControls = () => {
    if (this.firstMedia) {
      const mediaCenter = this.firstMedia.offsetTop + this.firstMedia.offsetHeight / 2;
      this.style.setProperty('--image-text-cards-arrow-top', `${mediaCenter}px`);
    }

    const canScroll =
      MOBILE_MEDIA_QUERY.matches &&
      this.cards.length > 1 &&
      this.scroller.scrollWidth > this.scroller.clientWidth + 1;

    this.previousButton.hidden = !canScroll;
    this.nextButton.hidden = !canScroll;
  };

  handleKeydown = (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.move(-1);
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.move(1);
    }
  };
}

if (!customElements.get('scrollable-image-cards')) {
  customElements.define('scrollable-image-cards', ScrollableImageCards);
}
